exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dialog-title[data-v-0ee7d002] {\n  white-space: normal;\n  overflow: visible;\n}\n\n/* When screen width is 600px or less */\n@media (max-width: 600px) {\n.dialog-title[data-v-0ee7d002] {\n    font-size:14px;\n}\n}\n", ""]);

// exports
